import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCircleIcon, ShieldCheckIcon, UserGroupIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

function UserProfile() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim() || 'Your account';
  const initials = `${String(user?.firstName || '').slice(0, 1)}${String(user?.lastName || '').slice(0, 1)}`
    .toUpperCase()
    || 'U';
  const handleClose = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate('/dashboard');
  };

  return (
    <div className="space-y-5">
      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
        <div className="flex items-center justify-between gap-3">
          <h1 className="text-2xl font-bold text-gray-900">My Profile</h1>
          <button
            type="button"
            onClick={() => navigate('/settings/sharing')}
            className="flex w-full items-start gap-3 rounded-xl border border-gray-200 bg-white p-3 text-left transition hover:bg-gray-50"
          >
            <UserGroupIcon className="mt-0.5 h-5 w-5 text-blue-600" aria-hidden="true" />
            <span>
              <span className="block text-sm font-semibold text-gray-900">Account sharing</span>
              <span className="block text-sm text-gray-600">Invite people and manage shared accounts.</span>
            </span>
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-gray-300 bg-white text-gray-700 transition hover:bg-gray-50"
            aria-label="Close profile"
          >
            <XMarkIcon className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
        <p className="mt-1 text-sm text-gray-600">Manage your account details and security options.</p>

        <div className="mt-5 flex flex-col gap-4 sm:flex-row sm:items-center">
          <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-blue-100 text-xl font-semibold text-blue-700">
            {initials}
          </div>
          <div className="min-w-0">
            <p className="truncate text-lg font-semibold text-gray-900">{fullName}</p>
            <p className="truncate text-sm text-gray-600">{user?.email || 'No email available'}</p>
          </div>
        </div>
      </div>

      <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6">
        <h2 className="text-base font-semibold text-gray-900">Account</h2>
        <div className="mt-3 space-y-3">
          <div className="flex items-start gap-3 rounded-xl border border-gray-200 bg-gray-50 p-3">
            <UserCircleIcon className="mt-0.5 h-5 w-5 text-gray-500" aria-hidden="true" />
            <div>
              <p className="text-sm font-semibold text-gray-900">Profile info</p>
              <p className="text-sm text-gray-600">Name and email are synced from your account.</p>
            </div>
          </div>
          <button
            type="button"
            onClick={() => navigate('/forgot-password')}
            className="flex w-full items-start gap-3 rounded-xl border border-gray-200 bg-white p-3 text-left transition hover:bg-gray-50"
          >
            <ShieldCheckIcon className="mt-0.5 h-5 w-5 text-blue-600" aria-hidden="true" />
            <span>
              <span className="block text-sm font-semibold text-gray-900">Reset password</span>
              <span className="block text-sm text-gray-600">Send a secure reset link to your email.</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default UserProfile;
